import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import AuthHeader from './AuthHeader'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import StyledButton from './inputs/StyledButton';
import BlueTypography from './typography/BlueTypography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import {
  is_logged_on,
  extract_errors,
  emailComp
 } from "../helpers"

import {
  LocalForm,
  Control,
} from 'react-redux-form'

import Errors from './Errors'
import EmailSent from './EmailSent'

import {
  validateEmailType,
  isRequired
} from "../validators"

import {
  request_password,
  request_password_reset
} from '../actions'

import {
  mailLink
} from '../services'

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

const mapDispatchToProps = dispatch => {
  return {
    requestPassword: values => dispatch(request_password(values)),
    requestReset: () => dispatch( request_password_reset() )
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    errors: state.auth.current_user.errors,
    request_sent: state.auth.resetSent
  };
}

class ConnectedForgot extends React.Component {
  constructor() {
    super()
    this.state = {
      emailValid: true,
      emailError: '',
      trouble: false,
      formValid: false
    }
  }

  handleSubmit(values) {
    this.setState({
      trouble: false
    })
    this.props.requestPassword(values)
  }

  handleUpdate(form) {
    const { email, $form } = form

    const emailState = (email.pristine || email.valid)
    const formState = $form.valid

    this.setState({
      emailValid: emailState,
      formValid: formState
    })
  }

  componentWillMount() {
    this.props.requestReset()
  }

  componentWillUnmount() {
    this.props.requestReset()
  }


  componentDidUpdate(prevProps, prevState){
    const { errors } = this.props
    const prevErrors = prevProps.errors

    const emailErrors = extract_errors(errors, "email")
    const prevEmailErrors = extract_errors(prevErrors, "email")

    if (emailErrors && !prevEmailErrors) {
      this.setState({
        emailValid: false,
        emailError: emailErrors,
        trouble: true
      })
    }

  }

  render() {
    // const {email, password, $form} = this.props.form
    if ( is_logged_on() ) {
      return <Redirect to="/" />
    }

    if (this.props.request_sent === true) {
      return <EmailSent />
    }

    return (
      <MuiThemeProvider theme={theme}>
        <section className="header">

        <AuthHeader />

        <div className="inner bottom-gap">
          <Grid container spacing={0} justify="center">
            <Grid item xs={12} md={4}>
              <Paper className="no-boxshadow">
                <LocalForm
                model="forgot"
                className="collection-item"
                initialState={{ email: ''}}
                onUpdate={(form) => this.handleUpdate(form)}
                onSubmit = {(values) => this.handleSubmit(values)}
              >
                <div>
                  <BlueTypography
                    className="ls-025"
                    variant="display1"
                    align="center"
                  >
                    Password Reset
                  </BlueTypography>

                  <div className="mt-24 mb-16">
                    <BlueTypography
                      className="lh-28 ls-050"
                      variant="subheading"
                      align="center"
                    >
                      To reset your password, enter the email address you use to sign in to InstaLevel.
                    </BlueTypography>
                  </div>

                </div>

                <div className="input-ls-015 mb-36">
                  <Control
                    id="forgot-email"
                    model="forgot.email"
                    component={emailComp}
                    error={!this.state.emailValid}
                    helperText={this.state.emailValid ? '' : this.state.emailError || "Not a valid Email" }
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      },
                      validateEmailType: (val) => validateEmailType(val)
                    }}
                  />
                 </div>

                  <Errors errors={this.props.errors} ignore={["email"]}/>

                  <StyledButton
                    size="large"
                    type="submit"
                    aria-label="Sumbit"
                    disabled={!this.state.formValid}
                    className="mdc-instalevel-w-100 ls-125"
                  >GET RESET LINK</StyledButton>

                </LocalForm>

                {
                  this.state.trouble && (
                    <div className="forgot-password ta-center mt-20">
                      <a
                        href={`mailto:${mailLink}?subject=Trouble logging in`}
                        target="_blank"
                        className="link no-t-decoration c-blue lh-28 ls-050"
                      >
                        Stuck? Contact help@instalevel.co.uk
                      </a>
                    </div>
                  )
                }

              </Paper>
            </Grid>
          </Grid>
        </div>

      </section>
      </MuiThemeProvider>
    )
  }
}

const Forgot = connect(mapStateToProps, mapDispatchToProps)(ConnectedForgot);

export default Forgot



// WEBPACK FOOTER //
// ./src/js/components/Forgot.js